// 道路監視カメラ公開用画面

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import axios from 'axios';
import * as commons from './commons';

import { NGINX_IMG_PATH, API_PATH } from './constant/constant';

/*-------------------
    cssのimport
---------------------*/

//クラス名
class PublicMonitorCamera extends Component {
  constructor(props) {
    super(props);

    document.title = `道路監視カメラ`;

    // URLを取得。
    const url = props.location.pathname;
    // 観測点コードを取得する。
    const num = url.lastIndexOf('/');
    const stationCd = url.slice(num + 1);
    // 市町村を取得する。
    const tmpLgCd = url.replace(`/${stationCd}`, '');
    const num2 = tmpLgCd.lastIndexOf('/');
    const lgCd = tmpLgCd.slice(num2 + 1);

    this.state = {
      stationCd,
      lgCd,
      resultFlag: '-1',
    };
  }

  componentDidMount = () => {
    this.getData();
  };

  /**
   * 観測点コードと市町村コードから最新の情報を取得する。
   *
   * @memberof PublicMonitorCamera
   */
  getData = async () => {
    const { stationCd, lgCd } = this.state;

    const result = await axios
      .post(`${API_PATH}/v/getDcame`, { stationCd, lgCd })
      .then((res) => {
        return res.data;
      })
      .catch(() => {
        window.alert('データの取得に失敗しました。');
        return '20';
      });

    if (result.toString() === '10') {
      this.setState({
        resultFlag: '10',
      });
      return;
    }

    if (result.toString() === '20') {
      this.setState({
        resultFlag: '20',
      });
      return;
    }

    const { recv = '', station } = result;
    const { date = '', filename } = recv;
    const {
      name: stationName = '',
      place_name: placeName = '',
      public_flag: publicFlag = '',
      route_name: routeName = '',
    } = station;

    if (publicFlag === false) {
      this.setState({
        resultFlag: '10',
      });
      return;
    }

    this.setState({
      resultFlag: '0',
      stationName,
      placeName,
      routeName,
      date,
      filename,
    });
  };

  render() {
    const { resultFlag, stationName, placeName, routeName, date, filename, lgCd } = this.state;

    return (
      <div id="container">
        {resultFlag === '0' ? (
          <div className="imageArea">
            {/* <div>{`${routeName} ${placeName} ${stationName}`}</div> */}
            <div className="imageContent">
              {routeName === '' ? null : (
                <div className="ml20">
                  <span className="label">路線名：</span>
                  {routeName}
                </div>
              )}
              {placeName === '' ? null : (
                <div className="ml20">
                  <span className="label">場所名：</span>
                  {placeName}
                </div>
              )}
              <div className="ml20">
                <span className="label">カメラ局名：</span>
                {stationName}
              </div>
            </div>
            <div className="ml20">
              <span className="label">撮影時間：</span>
              {commons.changeJapanDate(date, 'MM月DD日hh時mm分')}
              {/* <input
                type="submit"
                className="btn btnPrimary mr20"
                value="更新"
                style={{ float: 'right' }}
                onClick={() => this.getData()}
              /> */}
            </div>
            <div className="ml20 mr20">
              <img
                className="image-disp"
                src={`${NGINX_IMG_PATH}/${lgCd}/${filename}`}
                alt="画像の取得に失敗しました。"
                border="0"
              />
            </div>
            <div className="ml20 txtSmall">通信状況により画像が乱れることがあります。</div>
          </div>
        ) : null}
        {resultFlag === '10' ? (
          <div className="errPage">
            <div>404</div>
            <div>Not Found</div>
            <div>ページが見つかりませんでした。</div>
          </div>
        ) : null}
        {resultFlag === '20' ? (
          <div className="errPage">
            <div>501</div>
            <div>Not Implemented</div>
            <div>アクセスページは表示できませんでした。</div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default withRouter(PublicMonitorCamera);
